import { render, staticRenderFns } from "./PaymentStatusTag.vue?vue&type=template&id=5e97840f&scoped=true&"
import script from "./PaymentStatusTag.vue?vue&type=script&lang=js&"
export * from "./PaymentStatusTag.vue?vue&type=script&lang=js&"
import style0 from "./PaymentStatusTag.vue?vue&type=style&index=0&id=5e97840f&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e97840f",
  null
  
)

export default component.exports